export default function VideoEnableJsFilter(moduleName) {
    angular.module(moduleName || 'app')
        .filter('videoEnableJs', videoEnableJs);

    videoEnableJs.$inject = [];
    function videoEnableJs() {
        return function (markup, provider, id) {
            switch (provider) {
                case "YouTube":
                    return markup.replace("?", "?enablejsapi=1&origin=" + location.origin + "&").replace("<iframe", "<iframe id=\"" + id + "\"");
                case "Vimeo":
                    return markup.replace("<iframe", "<iframe id=\"" + id + "\"") + "<script>(function () { if (!document.getElementById('vimeo-script')) { var s = document.createElement('script'); s.id = 'vimeo-script'; s.type = 'text/javascript'; s.async = true; s.onload=window.vimeoPlayerReady; s.src = 'https://player.vimeo.com/api/player.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); } })();</script>";
                case "Wistia, Inc.":
                    return markup.replace("class=\"wistia_embed", "id=\"" + id + "\" class=\"wistia_embed");
            }
            return markup;
        };
    }
};